import {remCalc} from '_themeUtils'
import textStyles from 'overrides/app/theme/foundations/textStyles'

const productFindInBoutique = {
    ProductFindInBoutique: {
        baseStyle: () => ({
            container: {
                gap: 'spacing.10',
            },
            drawerHeaderWrapper: {
                gap: 'spacing.8',
            },
            drawerTitle: {
                // No case transformation: render the translation exactly as authored in the JSON.
                textTransform: 'none',
                textStyle: 'paragraphXl',
                fontWeight: 'normal',
                alignSelf: 'flex-start',
            },
            drawerSubtitle: {
                // No case transformation: render the translation exactly as authored in the JSON.
                textTransform: 'none',
                textStyle: 'paragraphXl',
                fontWeight: 'light',
                alignSelf: 'flex-start',
            },
            productInfoContainer: {
                w: '100%',
                alignItems: 'flex-start',
                gap: 'spacing.1',
            },
            productInfo: {
                textStyle: 'paragraphMd',
                fontWeight: 'normal',
            },
            chooseCountrySubtitle: {
                textStyle: 'paragraphLg',
            },
            infoText: {
                textStyle: 'paragraphMd',
                textAlign: 'left',
                w: '100%',
            },
            filterAvailableBoutiquesCheckbox: {
                mt: 'spacing.5',
                mb: 'spacing.5',
            },
            filterAvailableBoutiques: {
                textStyle: 'paragraphSm',
            },
            boutiqueItemContainer: {
                w: '100%',
                py: 'spacing.2',
            },
            boutiqueItemWrapper: {},
            boutiqueItemInfoContainer: {
                w: '100%',
                justifyContent: 'space-between',
            },
            boutiqueItemInfo: {
                alignItems: 'flex-start',
                gap: 'spacing.0.5',
            },
            boutiqueItemOpeningMobile: {
                alignItems: 'flex-start',
                gap: 'spacing.0.5',
                pb: 'spacing.1',
            },
            boutiqueItemName: {
                textStyle: 'paragraphLg',
                fontWeight: 'normal',
            },
            boutiqueItemAvailability: {
                textAlign: 'right',
            },
            boutiqueItemUnavailable: {
                color: 'color.text.error',
                textStyle: 'paragraphSm',
                fontWeight: 'normal',
            },
            boutiqueItemAvailableLow: {
                color: 'color.text.alert',
                textStyle: 'paragraphSm',
                fontWeight: 'normal',
            },
            boutiqueItemAvailable: {
                color: 'color.text.success',
                textStyle: 'paragraphSm',
                fontWeight: 'normal',
            },
            boutiqueItemButtonsContainer: {
                w: '100%',
                justifyContent: 'space-between',
                gap: 'spacing.6',
                flexDirection: {base: 'column', md: 'row'},
                // When the buttons sit side by side (md+), stretch them to the same height so the
                // taller Call button (two lines) drives the height of the row and the Book button
                // matches it instead of shrinking to its own content.
                alignItems: {md: 'stretch'},
            },
            boutiqueItemLinks: {
                w: '100%',
                // Make the link fill the stretched row height so the button inside can grow to it.
                display: {md: 'flex'},
                h: {md: 'auto'},
            },
            boutiqueItemCallButton: {
                w: '100%',
                p: 'spacing.3',
                h: '100%',
            },
            boutiqueItemButtonsText: {
                textStyle: 'paragraphMd',
                textTransform: 'uppercase',
            },
            boutiqueItemBookButton: {
                w: '100%',
                // Fill the stretched row height (md+) so the Book button matches the Call button.
                h: '100%',
                // On tablet (md) the drawer is narrower than on desktop, so the wide horizontal
                // padding pushed "Book an appointment" past the container and caused a horizontal
                // scroll. Trim the horizontal padding at md only (restored from lg up) so the
                // label can wrap onto two lines. Vertical size comes from the stretched row.
                px: {base: 0, md: 'spacing.3', lg: 'spacing.7'},
                py: {base: 0, md: 'spacing.3', lg: 'spacing.7'},
            },
            boutiqueItemBookButtonText: {
                textStyle: 'paragraphMd',
                textTransform: 'uppercase',
                // Allow the label to break onto two lines on tablet to avoid overflow; keep it on a
                // single line on mobile and desktop where there is enough room.
                whiteSpace: {base: 'nowrap', md: 'normal', lg: 'nowrap'},
                textAlign: 'center',
            },
        }),
    },
}

export default productFindInBoutique
